<template>
  <GridContainer>
    <RouterView v-if="!isLoading"/>
    <BaseLoader v-else/>
  </GridContainer>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { RouterView } from "vue-router";
import useIntentStore from "@/stores/intent";

const { fetchIntentList, fetchLanguages } = useIntentStore();
const isLoading = ref(false)

onMounted(async () => {
  try{
    isLoading.value = true
    await fetchIntentList();
    await fetchLanguages();
  } catch (e) {
    console.error(e)
  } finally {
    isLoading.value = false
  }
})
</script>
